import {List} from 'immutable';
import {invalidatePartialInterest} from 'resources/mandark.resource';
import {ClassroomModelV1} from 'resources/augmented/Classroom/ClassroomModel.v1';

import {getClassroomsForTeacherClassroomsDashboardQuery} from '../ClassroomsList/helpers';

/**
 * @typedef {import('@albert-io/json-api-framework/request/builder').QueryBuilder} QueryBuilder
 */

export const formValidators = {
  name(value) {
    if (!value) {
      return 'This field is required';
    }
    if (!value.trim()) {
      return 'Provide a valid class name';
    }
    if (value.length > 40) {
      return 'Name must be 40 characters or less';
    }
    return null;
  },
  schoolId(value) {
    if (!value) {
      return 'Select a school';
    }
    return null;
  },
  gradeLevels(value) {
    if (!value || !value.length) {
      return 'Select at least one grade level.';
    }
    return null;
  }
};

/**
 * @param {object} fields Form data
 * @param {string} fields.name Classroom name
 * @param {string} fields.schoolId School id to associate classroom to
 * @returns {?object} Object of fields and their errors, if any were encountered
 */
export function validateForm(fields) {
  const validationErrors = Object.entries(formValidators).reduce((acc, [field, validator]) => {
    const error = validator(fields[field]);
    if (error) {
      const errorObj = acc || {};
      errorObj[field] = error;
      return errorObj;
    }
    return acc;
  }, null);

  return validationErrors;
}

/**
 * @param {object} params Params
 * @param {string} params.teacherId Teacher id
 * @param {string} params.schoolId School id
 * @param {string} params.name Classroom name
 * @returns {Promise<*>} Promise
 */
export function createClassroom({teacherId, schoolId, name, gradeLevelIds}) {
  if (!teacherId || !schoolId || !name) {
    throw new Error('createClassroom is missing a required parameter');
  }
  return new ClassroomModelV1()
    .setName(name)
    .setStatus('active')
    .updateRelationship('teachers_v1', List([teacherId]))
    .updateRelationship('grade_levels_v1', gradeLevelIds)
    .updateRelationship('school_v5', schoolId)
    .save();
}

export function invalidateClassroomsQueries() {
  /**
   * @todo This is very coupled to this query. Ideally, we'd be able to invalidate all classrooms_v1 queries
   * in one fell swoop. Sadly, due to how `invalidatePartialInterest` works, this is not an easy task.
   */
  const {resourcePath} = getClassroomsForTeacherClassroomsDashboardQuery().done();
  invalidatePartialInterest({resourcePath});
}
